var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDropletIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 65,
    viewBox: "0 0 45 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5388 0.722863C22.8814 -0.240954 21.267 -0.240954 20.614 0.722863C19.7737 1.96971 0 31.2984 0 42.9234C0 55.0931 9.90797 64.9992 22.0758 64.9992C34.2455 64.9992 44.1522 55.0925 44.1522 42.9234C44.1534 31.2984 24.3785 1.96656 23.5388 0.722863ZM22.0764 61.4673C11.8514 61.4673 3.53316 53.1542 3.53316 42.9234C3.53316 34.8574 15.8006 14.4804 22.0764 4.90214C28.3541 14.4804 40.6209 34.8505 40.6209 42.9234C40.6209 53.1542 32.3002 61.4673 22.0764 61.4673ZM23.842 56.1692C23.842 57.145 23.0484 57.9354 22.0764 57.9354C13.7966 57.9354 7.06568 51.2019 7.06568 42.9241C7.06568 41.9514 7.86056 41.1578 8.83195 41.1578C9.80333 41.1578 10.5976 41.9514 10.5976 42.9241C10.5976 49.2573 15.747 54.4035 22.077 54.4035C23.0484 54.4029 23.842 55.1896 23.842 56.1692Z",
    fill: "#25A18E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropletIcon);
export default __webpack_public_path__ + "static/media/DropletIcon.f9ff9d0cd43758013065d8fdf40e6238.svg";
export { ForwardRef as ReactComponent };